import { FIRST_THG_YEAR } from "../ThgAnnualSummary.consts";

/** Days after 31 December before the backend treats a year as final. */
const GRACE_DAYS_IN_JANUARY = 14;

const BERLIN_DATE = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Berlin",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/**
 * Today's calendar date in Berlin.
 *
 * The backend decides FINAL vs PROVISIONAL in Berlin time, so the picker must too: a reader in another
 * zone around New Year would otherwise be offered a year the backend calls future, or miss one.
 */
export const berlinToday = (now: Date): { year: number; month: number; day: number } => {
  const parts = BERLIN_DATE.formatToParts(now);
  const get = (type: string) => Number(parts.find((p) => p.type === type)?.value);
  return { year: get("year"), month: get("month"), day: get("day") };
};

/** Every year that can be shown, newest first: from the first configured rate up to this year. */
export const availableYears = (now: Date): number[] => {
  const { year } = berlinToday(now);
  const years: number[] = [];
  for (let y = year; y >= FIRST_THG_YEAR; y -= 1) years.push(y);
  return years;
};

/**
 * The most recent FINAL year: last year from 15 January, the year before during the grace period.
 *
 * Never the current year, which is provisional by definition. Clamped to the first offered year, so the
 * one case where no final year exists yet opens on 2025 (shown as provisional) rather than on nothing.
 */
export const defaultYear = (now: Date): number => {
  const { year, month, day } = berlinToday(now);
  const inGrace = month === 1 && day <= GRACE_DAYS_IN_JANUARY;
  return Math.max(FIRST_THG_YEAR, year - (inGrace ? 2 : 1));
};
